import styled from "styled-components";
import { NAV_BAR_HEIGHT, SIDE_BAR_WIDTH } from "../contexts/Constants";
import { AddPitchSideButton, DashboardSideButton } from "../assets/Buttons";
import { useState } from "react";
import { useGlobalContext } from "../contexts/Constants";

const Container = styled.div`
  background-color: ${({ theme }) => theme.secondary};
  width: ${SIDE_BAR_WIDTH};
  height: 100%;
  gap: 0.5rem;
  color: ${({ theme }) => theme.white};
`;

const Logo = styled.h2`
  color: ${({ theme }) => theme.white};
  text-align: center;
  width: 100%;
  height: calc(${NAV_BAR_HEIGHT} - 0.0625rem);
  border-bottom: inset rgba(255, 255, 255, 0.1) 0.0625rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SideButtons = styled.div`
  width: 13.5rem;
  padding: 2rem 1rem;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

function Sidebar() {
  const [selectedActive, setSelectedActive] = useState<"dashboard" | "pitch">(
    "dashboard"
  );

  const { setSelectedPageState } = useGlobalContext();

  return (
    <Container>
      <Logo>SimpleSales</Logo>
      <SideButtons>
        <DashboardSideButton
          active={selectedActive === "dashboard"}
          onClick={() => {
            setSelectedActive("dashboard");
            setSelectedPageState("viewAll");
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.70828 0H1.45828C0.654141 0 0 0.654141 0 1.45828V5.20828C0 6.01258 0.654141 6.66672 1.45828 6.66672H7.70828C8.51258 6.66672 9.16672 6.01258 9.16672 5.20828V1.45828C9.16672 0.654141 8.51258 0 7.70828 0ZM7.70828 8.33328H1.45828C0.654141 8.33328 0 8.98742 0 9.79172V18.5417C0 19.3459 0.654141 20 1.45828 20H7.70828C8.51258 20 9.16672 19.3459 9.16672 18.5417V9.79172C9.16672 8.98742 8.51258 8.33328 7.70828 8.33328ZM18.5417 13.3333H12.2917C11.4874 13.3333 10.8333 13.9874 10.8333 14.7917V18.5417C10.8333 19.3459 11.4874 20 12.2917 20H18.5417C19.3459 20 20 19.3459 20 18.5417V14.7917C20 13.9874 19.3459 13.3333 18.5417 13.3333ZM18.5417 0H12.2917C11.4874 0 10.8333 0.654141 10.8333 1.45828V10.2083C10.8333 11.0126 11.4874 11.6667 12.2917 11.6667H18.5417C19.3459 11.6667 20 11.0126 20 10.2083V1.45828C20 0.654141 19.3459 0 18.5417 0Z"
              fill="white"
            />
          </svg>
          Dashboard
        </DashboardSideButton>
        <AddPitchSideButton
          active={selectedActive === "pitch"}
          onClick={() => {
            setSelectedActive("pitch");
            setSelectedPageState("add");
          }}
        >
          <svg
            width="16"
            height="19"
            viewBox="0 0 16 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.9943 0.687422C14.6677 0.355 14.2333 0.171875 13.7712 0.171875H13.004V0.953125C13.004 1.81469 12.3147 2.51562 11.4673 2.51562H4.55189C3.7045 2.51562 3.01512 1.81469 3.01512 0.953125V0.171875H2.24546C1.29323 0.171875 0.517693 0.959531 0.516617 1.92773L0.500001 17.2402C0.499463 17.7101 0.679078 18.152 1.00566 18.4845C1.33231 18.8169 1.76669 19 2.22885 19H13.7545C14.7067 19 15.4823 18.2123 15.4833 17.2441L15.5 1.93164C15.5005 1.46176 15.3209 1.01988 14.9943 0.687422ZM8.19592 6.03125H12.2903C12.6085 6.03125 12.8665 6.29359 12.8665 6.61719C12.8665 6.94078 12.6085 7.20312 12.2903 7.20312H8.19592C7.87765 7.20312 7.61965 6.94078 7.61965 6.61719C7.61965 6.29359 7.87765 6.03125 8.19592 6.03125ZM8.19592 9.9375H12.2903C12.6085 9.9375 12.8665 10.1998 12.8665 10.5234C12.8665 10.847 12.6085 11.1094 12.2903 11.1094H8.19592C7.87765 11.1094 7.61965 10.847 7.61965 10.5234C7.61965 10.1998 7.87765 9.9375 8.19592 9.9375ZM8.19592 13.8438H12.3067C12.625 13.8438 12.883 14.1061 12.883 14.4297C12.883 14.7533 12.625 15.0156 12.3067 15.0156H8.19592C7.87765 15.0156 7.61965 14.7533 7.61965 14.4297C7.61965 14.1061 7.87765 13.8438 8.19592 13.8438ZM3.28581 6.05437C3.51089 5.82555 3.87573 5.82555 4.10081 6.05437L4.41415 6.37301L5.74315 5.02176C5.96823 4.79297 6.33308 4.79289 6.55812 5.02176C6.78315 5.25055 6.78315 5.62156 6.55812 5.85039L4.82162 7.61594C4.76813 7.67034 4.70461 7.7135 4.63469 7.74295C4.56477 7.7724 4.48981 7.78755 4.41412 7.78755C4.33842 7.78755 4.26347 7.7724 4.19354 7.74295C4.12362 7.7135 4.0601 7.67034 4.00662 7.61594L3.28577 6.88297C3.06073 6.65418 3.06073 6.28316 3.28581 6.05437ZM3.28581 10.2589C3.51089 10.0301 3.87573 10.0301 4.10081 10.2589L4.41415 10.5775L5.74315 9.22629C5.96819 8.9975 6.33308 8.9975 6.55812 9.22629C6.78315 9.45508 6.78315 9.82609 6.55812 10.0549L4.82162 11.8205C4.76813 11.8749 4.70461 11.9181 4.63468 11.9475C4.56476 11.9769 4.48981 11.9921 4.41412 11.9921C4.33842 11.9921 4.26347 11.9769 4.19355 11.9475C4.12363 11.9181 4.0601 11.8749 4.00662 11.8205L3.28577 11.0875C3.06073 10.8588 3.06073 10.4878 3.28581 10.2589ZM3.28581 14.1652C3.51089 13.9364 3.87573 13.9364 4.10081 14.1652L4.41415 14.4838L5.74315 13.1325C5.96819 12.9038 6.33308 12.9038 6.55812 13.1325C6.78315 13.3613 6.78315 13.7323 6.55812 13.9612L4.82162 15.7268C4.76813 15.7812 4.70461 15.8243 4.63468 15.8537C4.56476 15.8832 4.48981 15.8983 4.41412 15.8983C4.33842 15.8983 4.26347 15.8832 4.19355 15.8537C4.12363 15.8243 4.0601 15.7812 4.00662 15.7268L3.28577 14.9938C3.06073 14.765 3.06073 14.394 3.28581 14.1652Z"
              fill="white"
            />
          </svg>
          Add Pitch
        </AddPitchSideButton>
      </SideButtons>
    </Container>
  );
}

export default Sidebar;
